import { Row, Col, Button } from 'react-bootstrap'

const Top = () => {
    const buttonCallOnClick = () => {
        var ex = document.getElementById('ex');
        ex.click();
    }

    const buttonLearnMoreOnClick = () => {
        document.getElementById('services').scrollIntoView({ behavior: 'smooth' });
    }
    
    return (
        <Row className="topBg" id="top">
            <Row className="top m-0">
                <Col className="my-auto p-0 mx-0">
                    <Row className="p-0 m-0">
                        <div className="topTitle">
                            SOFTWARE
                            <br/><span className="web3">&</span> AI SOLUTIONS
                        </div>
                    </Row>
                    <Row className="p-0 m-0">
                        <Col className="topDescription col-10 col-lg-8">
                        Linko Labs provides custom software development and AI integration services for businesses.
                        We help companies automate workflows, build intelligent systems, and develop custom web applications.
                            <br/><br/>
                            Projects are delivered under contract with milestone-based payments.
                        </Col>
                    </Row>

                    <Row className="p-0 m-0">
                        <Col className="m-0 p-0 mt-lg-4 mt-5 d-flex justify-content-start flex-wrap">
                            <Button onClick={buttonCallOnClick} className="callButton">Request a Consultation</Button>
                            <Button onClick={buttonLearnMoreOnClick} className="checkWorkButton">Learn More</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Row>
    );
}
export default Top